import {
  getShortenedUrlwithGeneral,
  sanitizeInnerHtml,
  sanitizeTextArticle,
} from "@/utils/helper"
import { ConditionalWrapper } from "@/utils/index"
import _isEmpty from "lodash/isEmpty"
import { useEffect, useRef, useState } from "react"
import { addTeaserDescriptionAnalytic } from "@/components/Default/Teaser/v1/analytics"

const Description = props => {
  const {
    linkURL = "",
    linkURLRef = "",
    linkNewTab = "",
    description = "",
    mainTitle = "",
    componentPosition = null,
    componentLinkType = null,
    pageType: serverPageType = "",
    linkDescription = false,
    general = {},
    expandText = "",
    collapseText = "",
    disableExpandCollapse = "",
    preTitle = "",
  } = props

  const [shortenedLinkUrl, setShortenedLinkUrl] = useState("")
  const [pageType, setPageType] = useState(serverPageType)
  const [target, setTarget] = useState("")
  const [details, setDetails] = useState(description)
  const [isPdp, setIsPdp] = useState("")
  const [linkText, setLinkText] = useState("")
  const [productInfo, setProductInfo] = useState(null)
  const isPlp = pageType === "plp"
  const containerRef = useRef(null)

  useEffect(() => {
    window.expandText = expandText
    window.collapseText = collapseText
    window.disableExpandCollapse = disableExpandCollapse
  }, [expandText, collapseText, disableExpandCollapse])

  useEffect(() => {
    const pageInfoDetails = window?.adobeDataLayer?.getState("page")
    if (
      serverPageType !== pageInfoDetails?.pageInfo?.contentType &&
      pageInfoDetails?.pageInfo?.contentType === "pdp"
    ) {
      setPageType(pageInfoDetails?.pageInfo?.contentType)
      setIsPdp(true)
    }
    if (pageInfoDetails?.productInfo) {
      setProductInfo(pageInfoDetails.productInfo)
    }
  }, [])
  const internalLinkPositionNotPdp = `${pageType.toLowerCase()}:${
    componentPosition ? componentPosition : "teaser"
  }`
  const internalLinkTypeNotPdp = `${pageType}:${
    componentLinkType ? componentLinkType : mainTitle.toLowerCase()
  }`
  let sanitizeDescription = sanitizeTextArticle(description).toLowerCase()
  useEffect(() => {
    if (linkURL) {
      const short = !_isEmpty(general)
        ? getShortenedUrlwithGeneral(linkURL, general)
        : linkURL
      setShortenedLinkUrl(short || linkURL)
    }
    if (description) {
      const shortDetails = !_isEmpty(general)
        ? getShortenedUrlwithGeneral(description, general)
        : description
      setDetails(shortDetails || description)
    }
  }, [linkURL, description, general])

  useEffect(() => {
    // pointerdown runs before click handlers in other scripts; use it to set the data attribute
    const handlePointerDown = e => {
      const targetEl = e.target
      if (targetEl && targetEl.tagName === "A") {
        const text = targetEl.textContent || ""
        const sanitizeDesc = text
          ? text.toLowerCase()
          : (targetEl.getAttribute("href") || "").toLowerCase()

        try {
          const eventInfo = addTeaserDescriptionAnalytic(
            targetEl.getAttribute("target") || "",
            isPdp,
            isPlp,
            pageType,
            internalLinkPositionNotPdp,
            preTitle,
            mainTitle,
            linkURL,
            internalLinkTypeNotPdp,
            sanitizeDesc,
            text
          )
          try {
            const outer =
              containerRef.current && containerRef.current.closest
                ? containerRef.current.closest(".cmp-teaser__description")
                : null
            if (outer) outer.setAttribute("data-gbh-data-layer", eventInfo)
          } catch (err) {
            /* ignore DOM failures */
          }
        } catch (err) {
          console.warn("Description: failed to build per-click analytics", err)
        }
      }
    }

    const handleClick = e => {
      const targetEl = e.target
      if (targetEl && targetEl.tagName === "A") {
        setLinkText(targetEl.textContent || "")
      }
    }

    const container = containerRef.current
    if (container) {
      container.addEventListener("pointerdown", handlePointerDown)
      container.addEventListener("click", handleClick)
    }

    return () => {
      if (container) {
        container.removeEventListener("pointerdown", handlePointerDown)
        container.removeEventListener("click", handleClick)
      }
    }
  }, [])

  sanitizeDescription = details.includes("href")
    ? linkText.toLowerCase()
    : sanitizeDescription

  // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
  useEffect(() => {
    if (linkNewTab) {
      setTarget("_blank")
    } else {
      setTarget("_self")
    }
  }, [linkNewTab])

  return (
    <div
      className="cmp-teaser__description"
      {...(productInfo && {
        "data-gbh-data-layer-custom": JSON.stringify({ productInfo }),
      })}
      data-gbh-data-layer={addTeaserDescriptionAnalytic(
        target,
        isPdp,
        isPlp,
        pageType,
        internalLinkPositionNotPdp,
        preTitle,
        mainTitle,
        linkURL,
        internalLinkTypeNotPdp,
        sanitizeDescription
      )}
    >
      <ConditionalWrapper
        condition={linkDescription}
        wrapper={children => (
          <a
            href={shortenedLinkUrl}
            rel={linkURLRef ? "noreferrer" : ""}
            target={target}
          >
            {children}
          </a>
        )}
      >
        <div ref={containerRef}>{sanitizeInnerHtml(details)}</div>
      </ConditionalWrapper>
    </div>
  )
}

export default Description
